<div>
    <ValidatedDropDown
      class="field"
      [label]="label"
      [selectedValue]="selectedState.code"
      [options]="stateOptions"
      [disabled]="disabled"
      (onValueChange)="onValueChange.emit(stateForCode($event))"
      [validators]="[notBlankValidator]"
    ></ValidatedDropDown>
</div>